import { css } from 'styled-components';

export const pxToRem = (pxValue: number, base = 16) => css`
  font-size: ${pxValue / base}rem;
`;

export const margin = (
  top: number | string,
  right: number | string = top,
  bottom: number | string = top,
  left: number | string = right,
  base = 16
) => css`
  margin: ${[
    typeof top === "number" ? `${top / base}rem` : top,
    typeof right === "number" ? `${right / base}rem` : right,
    typeof bottom === "number" ? `${bottom / base}rem` : bottom,
    typeof left === "number" ? `${left / base}rem` : left,
  ].join(" ")};
`;

export const padding = (
  top: number | string,
  right: number | string = top,
  bottom: number | string = top,
  left: number | string = right,
  base = 16
) => css`
  padding: ${[
    typeof top === "number" ? `${top / base}rem` : top,
    typeof right === "number" ? `${right / base}rem` : right,
    typeof bottom === "number" ? `${bottom / base}rem` : bottom,
    typeof left === "number" ? `${left / base}rem` : left,
  ].join(" ")};
`;